import template from './location.import_locations.html';
import controller from './location.import_locations.controller';
import './location.import_locations.scss';

let importLocationsComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template,
    controller
};

export default importLocationsComponent;


// WEBPACK FOOTER //
// ./client/app/components/location/import_locations/location.import_locations.component.js